var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("w-slider", {
    staticClass: "w-seek-minimal",
    attrs: {
      "no-labels": "",
      max: _vm.seconds,
      format: _vm.formatTime,
      value: _vm.value,
      size: _vm.size,
    },
    on: { input: _vm.input },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }